import { useNavigate } from 'react-router-dom';
import useSelectedCommunity from '../community/useSelectedCommunity';
import useEffectAfterFirstRender from './useEffectAfterFirstRender';

export default function useNavigateAfterCommunityChange() {
  const navigate = useNavigate();
  const community = useSelectedCommunity();

  useEffectAfterFirstRender(() => {
    if (community) {
      navigate('/overview');
    }
  }, [community?.id]);
}
